import { EPromoProductType, IPromoProduct } from '../../../types/product';
import { ILowRateMortgagePromo } from '../../../types/promosPage';

export const createAnalyticsProduct = (promo: ILowRateMortgagePromo, position: number): IPromoProduct => {
  return {
    id: promo.providerPromoId,
    offerType: 'promo',
    position,
    extra: {
      type: EPromoProductType.Mortgage,
    },
  };
};
